import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const SillHorn = ({ value, onChange, label = 'Sill Horn' }) => {
    const [selectedSillHorn, setSelectedSillHorn] = useState(value || '103"');

    const handleSillHornChange = (e) => {
        setSelectedSillHorn(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label style={{ display: "none" }} htmlFor="SillHorn">{label}</label>
            <input style={{ display: "none" }}
                id="SillHorn"
                value={selectedSillHorn}
                onChange={handleSillHornChange}
            >
             </input>
        </div>
    );
};

export default SillHorn;
